import { render, staticRenderFns } from "./LimitsWidget.vue?vue&type=template&id=7e2851a0&scoped=true"
import script from "./LimitsWidget.vue?vue&type=script&lang=js"
export * from "./LimitsWidget.vue?vue&type=script&lang=js"
import style0 from "./LimitsWidget.vue?vue&type=style&index=0&id=7e2851a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2851a0",
  null
  
)

export default component.exports